import { Title } from '@angular/platform-browser';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Client, XType, ScreenSize, Invoice } from 'src/app/models';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GenericService } from 'src/app/generic.service';
import { MatDialog } from '@angular/material/dialog';
import { OutUploadDialogComponent } from '../out-upload-dialog/out-upload-dialog.component';

@Component({
  selector: 'app-out-id-proof-f3',
  templateUrl: './out-id-proof-f3.component.html',
  styles: [
  ]
})
export class OutIdProofF3Component implements OnInit {
  @Input() client: Client;
  @Input() invoice: Invoice;
  @Input() uid: string;
  @Input() page: string;
  @Output() fdataChanged: EventEmitter<number> = new EventEmitter();
  f3loading = false;
  isFormChanged = false;
  title = 'Photo ID Proof';
  f3Form: FormGroup;
  addScript = false;

  f3PhotoIdList: XType[];
  size = new ScreenSize();

  constructor(private formBuilder: FormBuilder, public service: GenericService, public dialog: MatDialog) {
    this.size = this.service.size;
  }

  get f(): any { return this.f3Form.controls; }

  ngOnInit(): void {

  }

  attachFile(isreupload: boolean, type: string, title: string, fromname: string): void {
    let isIdUpload = false;
    let typeId = 0;

    if(type === 'id0') {
      isIdUpload = false;
      typeId = this.invoice.primaryTypeId;
    }

    if(type === 'id1') {
      isIdUpload = false;
      typeId = this.invoice.primaryTypeId;
    }

    if(type === 'id2') {
      isIdUpload = false;
      typeId = this.invoice.secondaryTypeId;
    }

    const dialogRef = this.dialog.open(OutUploadDialogComponent, {
      width: '300px;',
      data: { uid: this.invoice.uid, title: title, type: type, formname: fromname, typeId: typeId }
    });
    dialogRef.disableClose = true;

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // change here
        if(this.page === 'idupload')
        {
          window.location.reload();
        }else{
          this.fdataChanged.emit();
        }
      }
    });
  }

  viewFile(): void {
    this.service.viewDialog(this.invoice.primaryKey, null);
  }

  viewSecondaryFile(): void {
    this.service.viewDialog(this.invoice.secondaryKey, null);
  }

  attachSecondaryFile(isreupload: boolean): void {
    const dialogRef = this.dialog.open(OutUploadDialogComponent, {
      width: '300px;',
      data: { uid: this.invoice.uid, title: 'Non Photo ID Proof', type: 'Non Photo ID', formname: 'AF3S' }
    });
    dialogRef.disableClose = true;

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fdataChanged.emit();
      }
    });
  }

  viewSecondaryFile2(): void {
    this.service.viewDialog(this.invoice.secondaryKey2, null);
  }

  attachSecondaryFile2(isreupload: boolean): void {
    const dialogRef = this.dialog.open(OutUploadDialogComponent, {
      width: '300px;',
      data: { uid: this.invoice.uid, title: 'Non Photo ID Proof', type: 'Non Photo ID 2', formname: 'AF3S2' }
    });
    dialogRef.disableClose = true;

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fdataChanged.emit();
      }
    });
  }


}




